import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { labelCls, inputCls, primaryBtn, linkBtn, errorCls } from "./diaryStyles";

const FIELDS = [
  { k: "name", label: "First name", type: "text", ph: "e.g. Maria", ac: "given-name" },
  { k: "username", label: "Create a username", type: "text", ph: "3-20 letters, numbers or _", ac: "username" },
  { k: "email", label: "Email address (for account recovery and receipts only)", type: "email", ph: "you@example.com", ac: "email" },
  { k: "password", label: "Create a password", type: "password", ph: "At least 8 characters", ac: "new-password" },
  { k: "confirm", label: "Confirm password", type: "password", ph: "Type your password again", ac: "new-password" },
];

export const CreateDiaryForm = ({ onSuccess, onSignIn }) => {
  const { register } = useAuth();
  const [f, setF] = useState({ name: "", username: "", email: "", password: "", confirm: "" });
  const [agree, setAgree] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!f.name.trim() || !f.username.trim() || !f.email.trim()) { setError("Please fill in every field."); return; }
    if (f.password.length < 8) { setError("Your password needs at least 8 characters."); return; }
    if (f.password !== f.confirm) { setError("The two passwords don't match."); return; }
    if (!agree) { setError("Please agree to the Terms and Privacy Policy to continue."); return; }
    setLoading(true);
    try {
      onSuccess(await register(f.name.trim(), f.username.trim().toLowerCase(), f.email.trim(), f.password));
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Could not create your account.");
    } finally { setLoading(false); }
  };

  return (
    <form onSubmit={submit} data-testid="diary-create-form">
      {FIELDS.map((x, i) => (
        <div key={x.k} className={i ? "mt-3" : ""}>
          <label className={labelCls}>{x.label}</label>
          <input data-testid={`diary-create-${x.k}`} type={x.type} autoComplete={x.ac} value={f[x.k]} placeholder={x.ph}
            onChange={(e) => setF((p) => ({ ...p, [x.k]: x.type === "password" ? e.target.value : e.target.value.trimStart() }))} className={inputCls} />
        </div>
      ))}
      <label className="mt-4 flex items-start gap-2 text-[12px] leading-relaxed text-[#D6ECEE]">
        <input data-testid="diary-create-agree" type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} className="mt-0.5 h-5 w-5 shrink-0 accent-[#D1A33B]" />
        <span>I agree to the <a href="/terms" target="_blank" rel="noreferrer" className="underline">Terms and Privacy Policy</a>, including how my data is kept and deleted if I don't continue after the free trial.</span>
      </label>
      {error && <p data-testid="diary-create-error" className={errorCls}>{error}</p>}
      <button data-testid="diary-create-submit" type="submit" disabled={loading} className={primaryBtn}>{loading ? "Creating…" : "Create my account"}</button>
      <p className="mt-3 text-[12px] text-[#9DA79A]">Your email is used only for password recovery and receipts. We never ask for your phone number or home address.</p>
      <p className="mt-2 text-[12px] text-[#9DA79A]">Already have an account? <button type="button" data-testid="diary-back-to-signin" onClick={onSignIn} className={linkBtn}>Sign in</button></p>
    </form>
  );
};
